import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a bell icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BellIcon width={12} />
 */
const BellIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M38.65 30H38v-8.84c0-5.56-4.21-10.24-10-11.74a4 4 0 0 0-7.94 0c-5.65 1.41-10 6.18-10 11.74V30h-.9A3
        3 0 0 0 6 33a3.1 3.1 0 0 0 3.26 3h29.48A3.05 3.05 0 0 0 42 33v-.26c0-1.83-1.53-2.74-3.35-2.74zM24 42a4
        4 0 0 0 4-4h-8a4 4 0 0 0 4 4zm0 0a4 4 0 0 0 4-4h-8a4 4 0 0 0 4 4z`}
        />
    </SvgIcon>
)

BellIcon.defaultProps = defaultProps

export { BellIcon }
